"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RefCodesContainer;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _container = _interopRequireDefault(require("../../core/container"));
var _codeTypes = _interopRequireDefault(require("./code-types"));
var _refCodes = _interopRequireDefault(require("./ref-codes"));
var _notFound = _interopRequireDefault(require("../../not-found"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  component: _notFound.default
});
function RefCodesContainer({
  match: {
    path
  }
}) {
  return /*#__PURE__*/_react.default.createElement(_container.default, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path,
    component: _codeTypes.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/:codeType',
    component: _refCodes.default
  }), _ref));
}